module.exports = __webpack_public_path__ + "static/img/ezwel-renewal-img-02-01@m.7bda8e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/optimized/ezwel-renewal-img-02-01@m.jpg
// module id = QLCp
// module chunks = 0